/**
 * Rebate Rules Tab (campaign variant)
 * Composes the shared CampaignRulesTab shell with the rebate-specific sections
 */

import { memo, type FC } from 'react';

import { RulesTab as CampaignRulesTab } from '../../../../shared/tabs';
import { RebateRulesContent } from './RebateRulesContent/RebateRulesContent';

const RulesTab: FC = () => <CampaignRulesTab Content={RebateRulesContent} />;

export default memo(RulesTab);
